import ColorByStatus from './ColorByStatus'

function StudentStatus({ value }) {
  const statusMessages = {
    i: 'Datos incompletos',
    c: 'Esperando documentación',
    w: 'Validación pendiente',
    a: 'Apto para acreditación',
    p: 'Acreditación Completada',
    r: 'Rechazado',
    s: 'Acreditación pendiente Estampillas',
  }
  const error = ['c', 'i', 'w', 'r'].includes(value)

  return (
    <ColorByStatus
      error={error}
      message={statusMessages[value] || 'Estado ' + value}
    />
  )
}

export default StudentStatus
